/*
 Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential

 */

RCA.client.SpeakerPresentation = (function () {
    'use strict';
    /* ----- Declare Valiables ---------------------------------------------------------------------------------------- */
    let
        playbackController,
        soundController,
        presentationClock,
        debounce = false,
        initial_time = 0,
        speak_timer = 0,
        speak_timeout,
        on_air = false,
        speakers = [],
        started = false,
        channels = [],
        presi_id,
        block_id,
        start_slide = 0,
        timeout;


    function Init() {
        /* ----- iSpring Connector ---------------------------------------------------------------------------------------- */
        RCA.client.ispringPresentationConnector = RCA.client.ispringPresentationConnector || {};
        /* iSpring loads this adapter by its legacy parent-window name. */
        window.ispringPresentationConnector = RCA.client.ispringPresentationConnector;
        RCA.client.ispringPresentationConnector.register = function (player) {
            playbackController = player.view().playbackController();
            playbackController.gotoFirstSlide(true);
            presentationClock = playbackController.clock();
            soundController = player.view().soundController();
            soundController.mute(true);
            /*if ( localState.presentationState ) {
             var s = localState.presentationState;
             playbackController.gotoTimestamp( s.slideIndex, s.stepIndex, s.timeOffset, true );
             }*/

            playbackController.slideChangeEvent().addHandler(function(slideIndex)
            {
                console.log("blockid", block_id);

                if (start_slide > 0) {
                    gotoSlide(start_slide);
                    start_slide = 0;
                }

                if (block_id != undefined) {
                    $.ajax({
                        method: 'post',
                        url: 'api/',
                        data: {
                            do: "savePresentationCurrentSlide",
                            blockid: block_id,
                            slide_index: slideIndex
                        },
                        success: function(data) {
                            RCA.shared.AppData.presentations = data;
                            RCA.shared.Socket.Send('SpeakerPresentation.setPresis', data, {"client": ["client", "display"]});
                            RCA.shared.Socket.Send('Presentation.setPresis', data, {"client": ["display", "client"]});
                        }
                    });

                    console.log("change saved");
                }

                /*if ((AppData.profile.group === "speaker" || AppData.profile.group === "director") && on_air) {
                    Socket.Send('Presentation.gotoSlide', slideIndex, {
                        client: ['display', 'client'],
                        channel: channels.length == 0 ? [localState.currentChannel] : channels
                    });
                }*/
            });
        };

        $(document).on('keydown', function (e) {
            if ($('.speaker_presentation').is(':visible')) {
                var
                    code = e.wdich || e.keyCode,
                    key = e.key;
                /* Allowed Keys */
                if (['F11', 'F12'].includes(key)) {
                    return true;
                } else {
                    e.preventDefault();
                }
                /* Next Slide */
                if (['PageDown', ' ', 'ArrowDown', 'ArrowRight'].includes(key)) {
                    nextSlide();
                    //Socket.Send( 'Presentation.gotoTimestamp', localState.presentationState );
                    //Socket.Send('Presentation.nextSlide', true);
                }
                /* Prevouos Slide */
                if (['PageUp', 'Backspace', 'ArrowUp', 'ArrowLeft'].includes(key)) {
                    prevSlide();
                    //Socket.Send( 'Presentation.gotoTimestamp', localState.presentationState );
                    //Socket.Send('Presentation.prevSlide', true);
                }
                /* First Slide*/
                if (['Escape', 'F5'].includes(key)) {
                    firstSlide();
                    //Socket.Send( 'Presentation.gotoTimestamp', localState.presentationState );
                    //Socket.Send('Presentation.firstSlide', true);
                }
                /* Blank Screen */
                if (['.'].includes(key)) {
                    toggleBlank();
                    //Socket.Send('Presentation.toggleBlank', true);
                }
            }
        });

        onAir({presentations: RCA.shared.AppData.presentations});
    }

    function setTimer(time) {
        clearInterval(speak_timeout);
        started = false;
        if (time === "" || isNaN(time)) {
            time = 0;
        }
        speak_timer = parseInt(time);
        initial_time = parseInt(time);
        $(".timer", $(".speaker_presentation")).removeClass("warning finalwarning");
        showTime();
    }

    function startTimer() {
        if (!started && speak_timer > 0) {
            $(".timer", $(".speaker_presentation")).removeClass("warning finalwarning");
            speak_timeout = setInterval(function () {
                speak_timer--;
                if (speak_timer < 0) {
                    speak_timer = 0;
                }

                if (speak_timer < initial_time * 0.2) {
                    $(".timer", $(".speaker_presentation")).addClass("warning");
                }

                if (speak_timer < initial_time * 0.1) {
                    $(".timer", $(".speaker_presentation")).removeClass("warning").addClass("finalwarning");
                }

                showTime();
            }, 1000);
            started = true;
        }
    }

    function pauseTimer() {
        clearInterval(speak_timeout);
        started = false;
    }

    function resetTimer() {
        clearInterval(speak_timeout);
        started = false;
        speak_timer = 0;
        initial_time = 0;
        showTime();
        $(".timer", $(".speaker_presentation")).removeClass("warning finalwarning");
    }

    function onAir(data) {
        //on_air = parseInt(state.state) === 1 ? true : false;
        RCA.shared.AppData.presentations = data.presentations;

        channels = [];

        $.each(RCA.shared.AppData.presentations, function (i, item){
            if (item.speaker.indexOf(RCA.shared.AppData.profile.id) > -1 && item.onair == 1) {
                channels.push(item.channel);
            }
        });
    }

    function setSpeakers(data) {
        speakers = data;
    }

    function showTime() {
        var sec_num = parseInt(speak_timer, 10); // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) { hours   = "0"+hours; }
        if (minutes < 10) { minutes = "0"+minutes; }
        if (seconds < 10) { seconds = "0"+seconds; }

        $(".timer", $(".speaker_presentation")).html(hours+':'+minutes+':'+seconds);
    }

    /* ----- Control: Goto TimeStamp ---------------------------------------------------------------------------------- */
    function gotoTimestamp(slideIndex, stepIndex, timeOffset) {
        playbackController.gotoTimestamp(slideIndex, stepIndex, timeOffset);
        saveLocalState();
    }

    function gotoSlide(slide) {
        playbackController.gotoSlide(slide);
        saveLocalState();
    }

    /* ----- Control: First Slide ------------------------------------------------------------------------------------- */
    function firstSlide() {
        playbackController.gotoFirstSlide();
        saveLocalState();
    }

    /* ----- Control: Next Slide -------------------------------------------------------------------------------------- */
    function nextSlide() {
        playbackController.gotoNextStep();
        trySyncVideo();
        saveLocalState();

        console.log("next");

        if (RCA.shared.AppData.profile.presi_control == 1) {
            if (channels.length > 0) {
                var fn = 'Presentation.nextSlide';
                if (RCA.shared.AppData.modulsettings.presentation_usegotoslide) {
                    fn = 'Presentation.gotoSlide';
                }
                RCA.shared.Socket.Send(fn, playbackController.currentSlideIndex(), {
                    client: ['display', 'client'],
                    channel: channels
                });
            }

            RCA.shared.Socket.Send('SpeakerPresentation.nextSlideOwn', {client: "client"}, {"uid": speakers});
        }
    }

    function nextSlideOwn() {
        playbackController.gotoNextStep();
        trySyncVideo();
        saveLocalState();
    }

    /* ----- Control: Prevous Slide ----------------------------------------------------------------------------------- */
    function prevSlide() {
        playbackController.gotoPreviousSlide();
        trySyncVideo();
        saveLocalState();


        if (RCA.shared.AppData.profile.presi_control == 1) {
            if (channels.length > 0) {
                var fn = 'Presentation.prevSlide';
                if (RCA.shared.AppData.modulsettings.presentation_usegotoslide) {
                    fn = 'Presentation.gotoSlide';
                }
                RCA.shared.Socket.Send(fn, playbackController.currentSlideIndex(), {
                    client: ['display', 'client'],
                    channel: channels
                });
            }

            RCA.shared.Socket.Send('SpeakerPresentation.prevSlideOwn', {client: "client"}, {"uid": speakers});
        }
    }

    function prevSlideOwn() {
        playbackController.gotoPreviousSlide();
        trySyncVideo();
        saveLocalState();
    }

    /* ----- Control: Blank Screen Toggle ----------------------------------------------------------------------------- */
    function toggleBlank() {
        $('#iSpringFrame').contents().find('body').toggle();
    }

    /* ----- Control: iFrame Source ----------------------------------------------------------------------------------- */
    function source(src) {

        var presi = RCA.shared.AppData.medias.find(function (item) {
            return item.id == src;
        });

        var path = "";

        if (presi != undefined && presi.files[RCA.shared.localState.lang] != undefined) {
            path = presi.files[RCA.shared.localState.lang].foldername + "/";
            presi_id = src;
        }

        var
            $embed = $('#iSpringFrame'),
            $url = path + 'index.html';
        /* Change */
        if (src && $url !== $embed.attr('src')) {
            $embed.attr('src', $url);
            RCA.shared.localState.presentation = src;
        }

        /* Remove*/
        if (!src) {
            setTimeout(function () {
                $embed.removeAttr('src');
                delete RCA.shared.localState.presentation;
                delete RCA.shared.localState.presentationState;
            }, 1000);
        }

        if (RCA.shared.AppData.profile.presi_control == 1) {
            $(".prev_frame, .next_frame, .timer", $(".speaker_presentation")).show();

            $(".prev_frame", $(".speaker_presentation")).unbind("click").on("click", prevSlide);
            $(".next_frame", $(".speaker_presentation")).unbind("click").on("click", nextSlide);
        } else {
            $(".prev_frame, .next_frame, .timer", $(".speaker_presentation")).hide();
        }
    }

    /* ----- VideoPlayer Time Code -------------------------------------------------------------------------------------- */
    function trySyncVideo() {
        $('#iSpringFrame').contents().find('video').each(function () {
            var self = this;
            self.ontimeupdate = function () {
                if (!debounce) {
                    debounce = true;
                    RCA.shared.Socket.Send('Presentation.syncVideo', self.currentTime);
                    timeout = setTimeout(function () {
                        debounce = false;
                    }, 1000 / 60 * 45);
                }
            };
        });
    }

    /* ----- Save Last State ------------------------------------------------------------------------------------------ */
    function saveLocalState() {
        RCA.shared.localState.presentationState = {
            slideIndex: presentationClock.timestamp().slideIndex(),
            stepIndex: presentationClock.timestamp().stepIndex(),
            timeOffset: presentationClock.timestamp().timeOffset()
        };
    }

    function show(blockid) {

        /*var streamplayer = videojs('my-video');
        streamplayer.pause();
        $("#landing").find("#playerElement").hide();
        $("#landing").find(".videostream").hide();*/

        if ($(".presentation").is(":visible")) {
            $('#iSpringFrame_attendee').get(0).contentWindow.postMessage({action: "removeSrc"});
            $(".presentation").hide(400);
        }

        block_id = blockid;
        $(".speaker_presentation").fadeIn(400);
    }

    function hide() {
        $(".speaker_presentation").fadeOut(400);
    }

    function showList() {

        if ($(".speaker_presentation").is(":visible")) {
            hide();
            return;
        }

        var has_presi = RCA.shared.AppData.presentations.filter(function (item) {
            return item.speaker.indexOf(RCA.shared.AppData.profile.id) > -1;
        });

        if (has_presi) {
            var on_air_presi;
            for (var i = 0; i < has_presi.length; i++) {
                if (has_presi[i].onair == 1) {
                    on_air_presi = has_presi[i];
                    break;
                }
            }

            if (on_air_presi != undefined) {
                block_id = on_air_presi.id;
                if (on_air_presi.slide_index != undefined) {
                    start_slide = on_air_presi.slide_index;
                }
                source(on_air_presi.presi);
                show(block_id);
                setSpeakers(on_air_presi.speaker);
            } else {
                RCA.client.Modal.alert(RCA.shared.Language.getItem("no-running-presentation"));
            }
        } else {
            RCA.client.Modal.alert(RCA.shared.Language.getItem("no-presentation"));
        }
    }

    function setPresis(data) {
        RCA.shared.AppData.presentations = data;
    }

    /* ----- Process on Document Ready ---------------------------------------------------------------------------------- */
    $(function () {
        if (RCA.shared.localState.presentation) {
            //Presentation.source(localState.presentation);
        }
    });
    /* ----- Public API ----------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        gotoTimestamp: gotoTimestamp,
        gotoSlide: gotoSlide,
        firstSlide: firstSlide,
        nextSlide: nextSlide,
        prevSlide: prevSlide,
        nextSlideOwn: nextSlideOwn,
        prevSlideOwn: prevSlideOwn,
        toggleBlank: toggleBlank,
        setTimer: setTimer,
        startTimer: startTimer,
        pauseTimer: pauseTimer,
        resetTimer: resetTimer,
        onAir: onAir,
        show: show,
        hide: hide,
        source: source,
        setSpeakers: setSpeakers,
        setPresis: setPresis,
        showList: showList,
        playbackController: playbackController
    };
})();
